import { render } from "./pluginConfig.vue?vue&type=template&id=71357d22&scoped=true&ts=true"
import script from "./pluginConfig.vue?vue&type=script&lang=ts"
export * from "./pluginConfig.vue?vue&type=script&lang=ts"

import "./pluginConfig.vue?vue&type=style&index=0&id=71357d22&lang=scss"
import "./pluginConfig.vue?vue&type=style&index=1&id=71357d22&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71357d22"]])

export default __exports__